<template>
	<p class="uppercase text-xs font-main-bold py-4">
		Récapitulatif de la session
	</p>
</template>

<script>
	export default {
		name: 'ResultsHeader',
	}
</script>

<style lang="scss" scoped></style>
